import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetScheduleDelay = (params, endpoint?: string) => {
    return useQuery<string, QueryError, string, [QueryKeys, unknown]>({
        queryKey: ['getScheduleDelay', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId) && Boolean(params.contractId),
    });
};
